<template>  
    <el-container id="helpDetail" :class="{ overf: scoolfix }">
        <en-header @sendStatus="emitFun"></en-header>
        <div class="isSilderMenu"
         v-if="($route.query.type==2 && $route.path !='/webenterprise/login')
                || $route.path =='/webenterprise/homePage' 
                || $route.path =='/webenterprise/cooperate' 
                || $route.path =='/webenterprise/newsInfo'
                || $route.path == '/webenterprise/enhelpList'
                || $route.path == '/webenterprise/enAbout'
                || $route.path == '/webenterprise/jobHunting'
                || $route.path == '/webenterprise/course'
                "
        >
            <ul class="silderMenu-ul">
                <li class="silderMenu-li">
                     <div class="silderMenu-list" @click="openInfo">
                        <span class="icon-al-headset-fill"></span>   
                    </div>
                </li>
               <li class="silderMenu-li" v-if="$route.path == '/webenterprise/endowloadDetail' && helpID">
                    <div class="silderMenu-list" @click="openBz">
                        <span class="icon-al-question-circle"></span>   
                    </div>
                </li>
                <li class="silderMenu-li">
                        <el-tooltip placement="left" class="item" effect="light" :visible-arrow="false" popper-class="silderMenu-tips"  >
                    <div slot="content" class="silderMenu-phone flex">
                    <div class="icon-al-phone"></div>
                    <div class="silderMenu-phone-right">
                        <p>电话联系</p>
                        <p class="phone">
                            400-8811-519
                        </p>
                    </div>
                    </div>
                    <div class="silderMenu-list">
                         <span class="icon-al-mobile-alt"></span>   
                    </div>
                    </el-tooltip>
                </li>
                <li class="silderMenu-li">
                    <el-tooltip placement="left" class="item" effect="light" :visible-arrow="false" popper-class="silderMenu-tips"  >
                          <div slot="content">  
                            <img src="../assets/images/erweima.png" alt="">
                          </div>
                    <div class="silderMenu-list">
                        <span class="icon-al-qrcode"></span>
                    </div>
                    </el-tooltip>
                </li>
            </ul>
        </div>
        <el-main>
             <transition name="slide"><router-view /></transition>
        </el-main>
     <en-footer></en-footer>
     <div class="mask" id="mask" v-if="cenDiaog" @click="cenDiaog = false">
        <div class="mask-box" @click.stop>
            <div class="mask-top-pic">
                <span>客户咨询{{helpID}}</span>
            </div>
            <div class="mask-close01" @click="cenDiaog = false">
                <span>x</span>
            </div>
            <div class="mask-inner">
                 <el-form ref="ruleForm" :model="maskForm" label-width="100px" :rules="maskRules" class="edit-from">
                 <el-form-item label="咨询类型：" prop="type" class="mask-apptype">
                <el-radio v-model="maskForm.type" label="1"  @change="clearform">了解产品信息</el-radio>
                <el-radio v-model="maskForm.type" label="2" @change="clearform">业务合作</el-radio>
                 <el-radio v-model="maskForm.type" label="3" @change="clearform">推广合作</el-radio>
              </el-form-item>
               <div class="mask-public-info flex align-cen">
                  <div class="flex align-cen mask-sel" v-if="maskForm.type == 1">
                      <el-form-item label="产品信息：" prop="classifyId" class="nolbal1">
                 <el-select v-model="maskForm.classifyId" placeholder="请选择产品分类"
                clearable
                 @change="classSelect1"
                >
                    <el-option
                      v-for="item in options"
                      :key="item.id"
                      :label="item.name"
                      :value="item.id"
                      >
                    </el-option>
                  </el-select>
                 </el-form-item>
                      <el-form-item prop="appID" class="nolbal">
                 <el-select v-model="maskForm.appID" placeholder="请选择具体产品"
                clearable
                >
                    <el-option
                      v-for="item in dataList"
                      :key="item.id"
                      :label="item.appName"
                      :value="item.id"
                      >
                    </el-option>
                  </el-select>
                 </el-form-item>
                  </div>
                     <el-form-item label="手机：" prop="phone">
                    <el-input v-model="maskForm.phone" placeholder="请输入您的手机号码" clearable></el-input>
                </el-form-item>
                 <el-form-item label="姓名：">
                    <el-input v-model="maskForm.name" placeholder="请输入您的姓名" clearable minlength="1" maxlength="10"></el-input>
                </el-form-item>
                <el-form-item label="性别：">
                <el-radio v-model="maskForm.type1" label="男" >男</el-radio>
                <el-radio v-model="maskForm.type1" label="女">女</el-radio>
              </el-form-item>
              <el-form-item label="公司名称：" v-if="maskForm.type != 1">
                    <el-input v-model="maskForm.busName" placeholder="请输入您的公司名称" clearable></el-input>
                </el-form-item>
                 </div>
                 </el-form>
                 <el-button type="primary" :loading="loading"  class="mask-sureBtn" @click="submitCon('ruleForm')">确认</el-button>
                 <!-- <div class="mask-sureBtn" >确认</div> -->
            </div>
        </div>
     </div>
    </el-container>
</template>
<script>
let cozeWebSDK
 import enHeader from "./components/enterpriseHeader.vue"
 import enFooter from "./components/enterpriseFooter.vue"
 import {classList,ProductList,conSult,getCurrentUser} from "@/api/enterprise/index" // 分类、列表、新增客户咨询、用户信息
 import  Format from "../utils/auth.js"  
    export default {
        name: "enterprise",
        components: {
            enHeader,
            enFooter
        },
        data () {
            return {
                currentInfo:{},
                user:{},
                helpID:'',
                loading:false,
                itemList:[],
               cenDiaog:false,
               scoolfix:false,
               maskForm:{
                type:'1',
                classifyId:'',
                phone:'',
                name:'',
                type1:'',
                busName:'',
                appID:'',
               },
                dataList:[],
                options:[],
                fristId:'',
               maskRules:{
                type:[{ required: true, message: '请选择咨询类型', trigger: 'blur' }],
                classifyId: [{ required: true, message: '请选择产品分类', trigger: 'change' }],
                appID: [{ required: true, message: '请选择具体产品', trigger: 'change' }],
                phone:[
                    {
                        validator: Format.FormValidate.Form().Phone,   //validator： 自定义验证规则
                        trigger: "blur",
                        message:'请输入正确号码!',
                        required: true, 
                    }
                ],
               }
            }
        },
        created() {
    this.$bus.$off('isOv')
    this.$bus.$on("isOv", msg =>{ 
       this.scoolfix = msg
   })
    this.$bus.$off('helpID')
    this.$bus.$on("helpID", msg =>{ 
       this.helpID = msg || ''
   })
        },
        mounted() {
        },
        computed: {
        },

        watch: {},
        methods: {
            // 切换类型清空数据
            clearform(){
                this.$refs.ruleForm.clearValidate()
               
            },
            // 打开对应帮助文档
            openBz(){
                const newurl = this.$router.resolve({name: 'enhelpdetail', query: {id: this.helpID,type:1}})
                window.open(newurl.href,'_blank')
            },
        // 新增客户咨询
        submitCon(formName){
            let params
            if(this.maskForm.type == 1){
                params = {
                type:this.maskForm.type,
                phone:this.maskForm.phone,
                appClassifyId:this.maskForm.classifyId,
                appId:this.maskForm.appID,
                name:this.maskForm.name,
                sex:this.maskForm.type1,
                company:this.maskForm.busName
                }
            }else{
                params = {
                type:this.maskForm.type,
                phone:this.maskForm.phone,
                name:this.maskForm.name,
                sex:this.maskForm.type1,
                company:this.maskForm.busName
                }
            }
                this.$refs[formName].validate((valid) => {
                    if(valid){
                        this.loading = true
                         conSult(params,'enterprise')
                         .then(res => {
                            this.loading = false
                            if(res.code == 0){
                                this.$util.Notifi('咨询提交成功，请等待工作人员联系您','success','fa-check'); 
                                this.cenDiaog = false
                            }else{
                                this.$util.Notifi(res.msg,'error','fa-exclamation-circle');
                            }
                         })
                         .catch(err =>{
                             this.loading = false
                             this.$util.Notifi(res.msg,'error','fa-exclamation-circle');
                         })
                    }
                })
        },
        // 删选
        classSelect1(val){
            this.maskForm.appID = ""
             this.gethisList(val)
        },
        // 打开咨询窗口
        openInfo(){
            this.itemList = []
            this.cenDiaog = true
            this.maskForm = {
                type:'1',
                classifyId:'',
                phone:'',
                name:'',
                type1:'',
                busName:'',
                appID:'',
               },
            this.gethisClass().then(res => {
              this.gethisList(this.fristId)
            })
        },
             // 获取产品分类
             async gethisClass(){
            await  classList({},'enterprise',1)
            .then(res => {
                if(res.code == 0){
                 this.options = res.data
               this.fristId = res.data[0].id
                }
            })
            .catch(err => {
            })
        },
            // 获取产品列表
        gethisList(id){
            ProductList({id:id},'enterprise',1)
            .then(res =>{
                this.fristId = id
                if(res.code == 0){
                    this.dataList = res.data
                //      this.itemList = []
                //     for (const key in this.options) {
                //         this.itemList.push({
                //             value:this.options[key].id,
                //             label:this.options[key].name,
                //             children:[]
                //         })
                //   for (const i in this.dataList) {
                //         this.itemList[key].children.push({
                //             value:res.data[i].id,
                //             label:res.data[i].appName
                //         })
                //     }
                //     }
                }
            })
        },
            emitFun(val){
               this.scoolfix = val
            }
        },
        destroyed(){
             this.$bus.$off('isOv')
            this.$bus.$off('helpID')
        },
    }
</script>
<style lang="scss" scoped>
#helpDetail{
    width: 100%;
    height: 100vh;
    .mask{
    position: fixed;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    text-align: center;
    z-index: 999;
    background: rgba(0,0,0,.6);
    box-sizing: border-box;
    .mask-box{
    display: inline-block;
    width: 80%;
    max-width: 986px;
    vertical-align: middle;
    text-align: left;
    overflow: hidden;
    backface-visibility: hidden;
    padding-top: 38px;
    position: relative;
    .mask-top-pic{
    position: absolute;
    top: 7px;
    left: 0;
    span{
     background: url('../assets/images/experiences.png') no-repeat;
    background-size: 100% 100%;
    width: 368px;
    height: 94px;
    display: block;
    font-size: 22px;
    color: #fff;
    line-height: 118px;
    padding-left: 104px;
    box-sizing: border-box;
    }
    }
    .mask-close01{
    color: #6e6e6e;
    font-size: 24px;
    position: absolute;
    top: 48px;
    right: 10px;
    width: 30px;
    height: 30px;
    cursor: pointer;
    text-align: center;
    vertical-align: middle;
    font-weight: 700;
    line-height: 1;
    text-shadow: 0 1px 0 #fff;
    }
    .mask-inner{
    background: #fff;
    border-radius: 4px;
    box-shadow: 0 3px 7px 0 rgba(100,100,100,.25);
    padding: 92px 60px 46px 60px;
    font-size: 14px;
    .mask-apptype{width: 100% !important;}
    .mask-public-info{flex-wrap: wrap;
    .mask-sel{
        width: 50%;
    }
    }
    .edit-from{
        padding: 50px 0 0 0;
        .el-form-item{
            width: 50%;
            padding-bottom: 30px;
         .el-cascader{
            width: 100%;
        }

        }
    }
    .mask-sureBtn{
        cursor: pointer;
        width: 270px;
    height: 40px;
    background-image: linear-gradient(90deg, #4A77ED 9%, #21CDDE 95%);
    border-radius: 4px;
    color: #fff;
    display: block;
    margin: 0 auto;
    font-size: 14px;
    line-height: 40px;
    padding: 0;
    text-emphasis: none;
    text-align: center;
    cursor: pointer;
    }
    }
    }
    }
    .mask:after {
     content: "";
    display: inline-block;
    height: 100%;
    width: 0;
    vertical-align: middle;
    box-sizing: border-box;
    }
    .isSilderMenu{
        position: fixed;
        bottom: 10%;
        right: 20px;
        z-index: 200;
        .silderMenu-ul{
            // display: none;
          box-shadow: 0 0 7px 3px rgba(100, 100, 100, .1);
          .silderMenu-li{
             position: relative;
             .silderMenu-list{
                width: 54px;
                height: 54px;
                background-color: #fff;
                text-align: center;
                line-height: 54px;
                cursor: pointer;
                span{
                    color: #333;
                    font-size: 24px;
                }
             }
            .silderMenu-list:hover{
                background:#2893f1;
                span{color: #fff;}
            }
          }
                       .silderMenu-li:first-child .silderMenu-list{
            border-radius: 4px 4px 0 0;
             }
             .silderMenu-li:last-child .silderMenu-list{
                border-radius: 0 0 4px 4px;
             }
         }
    }
}
     /*滚动条样式*/
        #helpDetail::-webkit-scrollbar {
            width: 4px;    
        }
       #helpDetail::-webkit-scrollbar-thumb {
            border-radius: 10px;
            box-shadow: inset 0 0 5px rgba(0,0,0,0.2);
            background: rgba(0,0,0,0.2);
        }
        #helpDetail::-webkit-scrollbar-track {
            box-shadow: inset 0 0 5px rgba(0,0,0,0.2);
            border-radius: 0;
            background: rgba(0,0,0,0.1);

        }
.overf{
    overflow: hidden;
}

@media (max-width: 640px){
    .el-main{
        padding-top: 56px;
    }
    .mask-inner{
        padding: 92px 0 46px 0 !important;
       .el-form-item{
        width: 100% !important;
        padding-bottom: 10px !important;
        .el-input{
            width: 85% !important;
        }

       }
               .mask-sel{
            display: block !important;
            width: 100% !important;
        } 
    }
}
::v-deep{

    .mask-public-info{
          .nolbal{
        .el-form-item__content{
            margin-left: 50px !important;
        } 
    }
              .nolbal1{
        .el-form-item__content{
           width: 75% !important;
        }
         }
               .el-input__inner:focus{
            color: #495057;
    background-color: #fff;
    border-color: #80bdff !important;
    outline: 0;
    box-shadow: 0 0 0 0.2rem rgba(0,123,255,.25);
        }
    }
       @media (max-width: 640px){
        .mask-public-info{
          .nolbal{
        .el-form-item__content{
            margin-left: 100px !important;
            width: 50% !important;
        } 
        
    }
    .nolbal1{
          .el-form-item__content{
            width: 50% !important;
        } 
        }
        .el-form-item__content{
            width: 60% !important;
        } 
        }
    }
}
</style>
<style >
     .silderMenu-tips{
         border: none !important;
             box-shadow: 0 0 7px 3px rgba(100, 100, 100, .1);
    }
    .silderMenu-tips img{
        width: 80px;
        height: 80px;
    }
    .silderMenu-phone {
        padding: 0px 10px;
    }
    .silderMenu-phone-right{
        margin-left: 10px;
    }
     .silderMenu-phone-right p{
        padding-bottom: 5px;
        color: #999;
     }
     .silderMenu-phone-right .phone{color:#2893f1;}
</style>